import { useEquipment } from "@/lib/equipment";

/** Suggestions for the Equipment I.D. box of a production sheet: the machines of the right type, picked by code.
 *  Typing something else still works. */
export default function EquipmentOptions({ types }) {
  const rows = useEquipment(types);
  return <datalist id="equipment-ids">{rows.map((e) => <option key={e.id} value={e.code || e.name}>{e.name}{e.make ? ` · ${e.make}` : ""}</option>)}</datalist>;
}
